/**
 *
 *
 * @export GetMarkFileRequestModel
 * @class GetMarkFileRequestModel
 */
export class GetMarkFileRequestModel {
    // マーク名
    public MarkName: string = <string>'';
    // マークファイル名
    public MarkFileName: string = <string>'';
    // マークグループコード
    public MarkGroupCode: string = <string>'';
    // 供給促進マーク区分
    public SupplyPromoteMarkDiv: string = <string>'';
    // マーク登録日(FROM)
    public RegistMarkDateFrom: string = <string>'';
    // マーク登録日(TO)
    public RegistMarkDateTo: string = <string>'';
    // マークファイル登録日(FROM)
    public FileRegistDateFrom: string = <string>'';
    // マークファイル登録日(TO)
    public FileRegistDateTo: string = <string>'';
    // マークファイル未登録のみ
    public FileNonRegistOnly = false;
    // 使用停止マークのみ
    public UnableOnly = false;

    /**
     * マークグループリスト
     *
     * @type {Array<any>}
     * @memberof GetMarkFileRequestVO
     */
    public markGroupList: Array<any> = new Array<any>();

    /**
     * 供給促進マーク区分リスト
     *
     * @type {Array<any>}
     * @memberof GetMarkFileRequestVO
     */
    public supplyPromoteMarkDivList: Array<any> = new Array<any>();


    /**
     * コンストラクタ
     * 変数の初期化のみを行う。
     */
    constructor() {
    }
}
